import React, { useState } from 'react'

import { StripeBalanceObject } from '../../api/services/stripe/types.ts'
import { formatCurrency } from '../../utils/payments.ts'
import Button from '../common/Button/Button.tsx'
import Popup from '../common/Popup/Popup.tsx'
import PayoutPopup from './PayoutPopup.tsx'

type BalanceItemProps = {
  label: string
  data: StripeBalanceObject<string, undefined> | null
  type: 'pending' | 'available'
  setRefetch: React.Dispatch<React.SetStateAction<number>>
}

const BalanceItem = (props: BalanceItemProps) => {
  const { data, type, label, setRefetch } = props
  const [isPopupVisible, setIsPopupVisible] = useState(false)

  if (!data) return null

  const { amount, currency } = data[type][0]

  const onClosePopup = () => {
    setIsPopupVisible(false)
  }

  return (
    <div className="flex-1 flex-row justify-between items-center mb-12 border-b-2 dark:border-b-gray-700 text-xl">
      <div className="flex justify-between items-center mb-4">
        <p className="font-bold">{label}</p>
        {amount > 500 && type === 'available' && (
          <Button
            variant="filled"
            size="medium"
            color="primary"
            type="button"
            className="mb-3"
            onClick={() => setIsPopupVisible(true)}
          >
            {'Wypłać'}
          </Button>
        )}
      </div>
      <div className="flex justify-between items-center mb-4">
        <p>Kwota</p>
        <div className="flex gap-2 font-bold">
          <p>{formatCurrency(amount)}</p>
          <p>{String(currency).toUpperCase()}</p>
        </div>
      </div>
      <Popup isVisible={isPopupVisible} onClose={onClosePopup}>
        <PayoutPopup
          initialAmount={amount / 100}
          setIsPopupVisible={setIsPopupVisible}
          setRefetch={setRefetch}
        />
      </Popup>
    </div>
  )
}

export default BalanceItem
